import { Grid } from '@material-ui/core';
import React from 'react';
import { CssTextField } from 'src/price-override/components/price-override-input/price-override-input-styles';
import { transactionSearchModalStyles } from 'src/transaction-search/transaction-based-return-styles';
import { PosFilterAction } from './enumerations/pos-filter-action';

const FilterTextField = ({
  input,
  action,
  focusedAction,
  onChange,
  onFocus,
  onKeyDown,
}: FilterTextInputProps): JSX.Element => {
  const classes = transactionSearchModalStyles();

  const isFocused = action === focusedAction;

  return (
    <Grid container className={classes.containerHeight}>
      <Grid item data-testid='search-input-text'>
        <CssTextField
          variant='outlined'
          label='Pos Number'
          autoComplete='off'
          className={`${classes.textFieldInput}`}
          id={action}
          name={action}
          onFocus={onFocus}
          inputProps={{
            'data-testid': `filter-table-input`,
            'data-keyboard-owner': `recall-transaction-focus`,
          }}
          value={isFocused ? input : ''}
          autoFocus={action === PosFilterAction.FilterPos}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
      </Grid>
    </Grid>
  );
};

export interface FilterTextInputProps {
  key: string;
  input: string;
  action: PosFilterAction;
  focusedAction: PosFilterAction;
  onChange: (e) => void;
  onFocus: (e) => void;
  onKeyDown: (e) => void;
}

export default FilterTextField;
